import { useQuery } from 'react-query';
import { getOrders } from '../../services/order.service';

export const getOrdersQueryKey = 'getOrders';
export const useOrdersList = (params: Record<string, any>) => useQuery([getOrdersQueryKey, params], () => getOrders(params)
  .then((result) => result.data), {
  refetchOnWindowFocus: false, retry: false, cacheTime: 0,
});
